export default "__VITE_ASSET__34ee924e__"